import { BodyCell } from '@tableau/widgets-datagrid';
import React from 'react';

import { ScheduleActions } from '~src/schedule/types/ISchedule';
import { IScheduleInfo } from '~src/schedule/types/IScheduleInfo';

import { Messages } from '../../../../codegen/Localize';
import { StyledCellFormatter } from '../StyledCellWrapper';
import { CreateCellText } from './PlainTextAndNumberCells';

export function LinkedTaskCell(): React.StatelessComponent<BodyCell.Props> {
    return StyledCellFormatter(
      function LinkedTaskCell(props: BodyCell.Props) {
        const row = props.row;
        const schedule = row.data as IScheduleInfo;
        if (schedule.scheduledAction !== ScheduleActions.Flow) {
         return CreateCellText(Messages.linkedTasksNotAvailable());
        } else if (schedule.enabledForLinkedTasks) {
          return CreateCellText(Messages.linkedTasksConfigured());
        } else {
          return CreateCellText(Messages.linkedTasksNotConfigured());
        }
      }
    );
  }
